export type ClientsNullKpiKey =
  | 'name'
  | 'legalName'
  | 'docType'
  | 'docNumber'
  | 'type'
  | 'status'
  | 'unitsCount'
  | 'volumeMwm'
  | 'exposure'
  | 'exposurePercentage';

export interface ClientsNullKpiItem {
  key: ClientsNullKpiKey;
  label: string;
  hint?: string;
  required?: boolean;
  /** Texto sob a contagem quando "vazio" não descreve o card. */
  emptyLabel?: string;
}

export const CLIENTS_NULL_KPI_ITEMS: ClientsNullKpiItem[] = [
  { key: 'name', label: 'Empresa', required: true },
  { key: 'legalName', label: 'Razão social' },
  { key: 'docType', label: 'Tipo doc' },
  { key: 'docNumber', label: 'CNPJ/CPF' },
  { key: 'type', label: 'Tipo', required: true },
  { key: 'status', label: 'Status', required: true },
  {
    key: 'unitsCount',
    label: 'Qtd. de unidades',
    hint: 'Empresa sem unidades',
    emptyLabel: 'sem unidades',
  },
  { key: 'volumeMwm', label: 'Volume (MWm)', required: true },
  { key: 'exposure', label: 'Exposição', required: true },
  { key: 'exposurePercentage', label: '% Exposição', required: true },
];

export const EMPTY_NULL_KPIS: Record<ClientsNullKpiKey, number> = {
  name: 0,
  legalName: 0,
  docType: 0,
  docNumber: 0,
  type: 0,
  status: 0,
  unitsCount: 0,
  volumeMwm: 0,
  exposure: 0,
  exposurePercentage: 0,
};
